module.exports = __webpack_public_path__ + "img/H0-1800w.dd6dbce3.jpg";